<!--The content below is only a placeholder and can be replaced.-->
<div style="text-align:center">
  <h1>
    {{ 'APP.WELCOME' | translate:{ param: appName } }}
  </h1>
</div>
<p>
  <locale-select></locale-select>
</p>

<router-outlet></router-outlet>
